import React, { useState, useEffect, useCallback, useRef } from 'react';
import toast from 'react-hot-toast';
import { api } from '../../api';

const AddFingerprintModal = ({ device, person, onClose }) => {
    const [status, setStatus] = useState('initiating'); // 'initiating', 'scanning', 'success', 'error'
    const [errorMessage, setErrorMessage] = useState('');
    
    const pollingIntervalId = useRef(null);
    const timeoutId = useRef(null);

    // This effect runs once to start the process
    useEffect(() => {
        const initiate = async () => {
            try {
                // Use the person's existing employee_code
                await api.initiateFpEnrollment(device.id, { userId: person.employee_code });
                toast.success('Device is ready. Please scan your finger.');
                setStatus('scanning');
            } catch (error) {
                setErrorMessage(error.message || 'Failed to start enrollment mode.');
                setStatus('error');
            }
        };
        initiate();
    }, [device.id, person.employee_code]);

    // This effect starts polling when the status is 'scanning'
    useEffect(() => {
        if (status !== 'scanning') return;

        const startPolling = () => {
            timeoutId.current = setTimeout(() => {
                clearInterval(pollingIntervalId.current);
                setErrorMessage("Enrollment timed out.");
                setStatus('error');
            }, 60000);

            pollingIntervalId.current = setInterval(async () => {
                try {
                    // Poll the NEW lightweight endpoint
                    const response = await api.checkAddFingerStatus(device.id, person.employee_code);
                    if (response.status === 'finger_added') {
                        clearInterval(pollingIntervalId.current);
                        clearTimeout(timeoutId.current);
                        toast.success(response.message);
                        setStatus('success');
                        setTimeout(onClose, 1500); // Close modal after success
                    }
                } catch (error) {
                    clearInterval(pollingIntervalId.current);
                    clearTimeout(timeoutId.current);
                    setErrorMessage(error.message || 'An error occurred while polling.');
                    setStatus('error');
                }
            }, 3000);
        };

        startPolling();

        return () => {
            if (pollingIntervalId.current) clearInterval(pollingIntervalId.current);
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, [status, device.id, person.employee_code, onClose]);
    
    const renderContent = () => {
        switch (status) {
            case 'scanning':
                return (
                    <>
                        <div className="spinner"></div>
                        <p className="mt-4 font-semibold">Waiting for Scan</p>
                        <p className="form-help-text">Please ask {person.first_name} to scan their additional finger.</p>
                    </>
                );
            case 'success':
                return <p className="font-semibold text-green-600">✅ New Fingerprint Enrolled!</p>;
            case 'error':
                 return (
                    <>
                        <p className="font-semibold text-red-600">Enrollment Failed</p>
                        <p className="form-help-text mb-4">{errorMessage}</p>
                    </>
                );
            default:
                return <p>Initiating enrollment...</p>;
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content text-center">
                <div className="modal-header">
                    <h2 className="modal-title">Enroll Additional Fingerprint</h2>
                </div>
                <div className="modal-body">
                    {renderContent()}
                    <div className="modal-actions" style={{ justifyContent: 'center', marginTop: '1rem' }}>
                       {status === 'error' && <button type="button" className="button button-secondary" onClick={onClose}>Close</button>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddFingerprintModal;